import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["provider", "useBrandColors"];
import { View } from 'foundations-components/components/View';
import { OAuthButtonContext } from './OAuthButtonContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const Root = _ref => {
  let {
      provider,
      useBrandColors = true
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(OAuthButtonContext.Provider, {
    value: {
      provider,
      useBrandColors
    },
    children: /*#__PURE__*/_jsx(View, Object.assign({}, props))
  });
};